const errorTemplate = {
  event: null, // A custom event
  code: null, // The error code, usually of the range 400 - 499
  error_name: null, // A literal
  details: null, // The nature of the error (e.g. “restricted_to_brokers”, etc.)
};

export default errorTemplate;
